import { DroppableSharedProps } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityRanking/securityRankingTypes.ts';
import { useDroppable } from '@dnd-kit/core';

export const DroppableRankContainer = ({
	id,
	children,
	isOver,
	sticky,
}: DroppableSharedProps & { sticky?: boolean }) => {
	const { setNodeRef } = useDroppable({
		id,
	});

	return (
		<div
			ref={setNodeRef}
			className={sticky ? 'droppable-rank-sticky' : undefined}
			style={{
				backgroundColor: isOver ? 'rgba(0, 123, 255, 0.1)' : 'transparent',
				borderRadius: '0.25rem',
				transition: 'background-color 0.2s',
			}}
		>
			{children}
		</div>
	);
};
